module.exports = __webpack_public_path__ + "img/pixel_portrait.badc127a.png";